import React, { useEffect, useState } from "react";
import TriggerEmergencyStyle from "./TriggerEmergency.module.css";
import { Heading, Input, InputGroup, InputLeftAddon, Button, Image, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { useGeolocated } from "react-geolocated";
import { useParams } from "react-router";
import { useNavigate, useLocation } from "react-router";
import { ShowAlert } from "../../GlobalComponents/ShowAlert/ShowAlert";
import Timer from "../../GlobalComponents/Timer/Timer";
import { qrCall } from "./Action/qrWithoutMobile";
import { checkBenIdIsMapped, raiseEmergencyWithCompanyIdAction } from "./Action/companyCall";
import { qrEmergencyWithMobile } from "./Action/qrWithMobile";
import axios from "axios";
import apiConfig from "../../apiConfig/apiConfig";
import { wordpressBaseUrl } from "../../wordpressApiConfig/wordpressApiConfig";

const TriggerEmergency = () => {
  const baseUri = apiConfig.api.baseURL
  const navigate = useNavigate();
  const { coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: Infinity,
  });

  const [mobile, setMobile] = useState("");
  const { companyId } = useParams<{ companyId: string }>();
  const [autoCall, setAutoCall] = useState(true); // eslint-disable-line
  const [buttonClicked, setButtonClicked] = useState(false);
  const [errorHandled, setErrorHandled] = useState(false);
  const [isQrMapped,setIsQrMapped]=useState(false);
  const wpBaseUrl = wordpressBaseUrl();
  const { search } = useLocation();
  const isSso = new URLSearchParams(search).get("source") === "sso";

  const handleAutoCall = async () => { // eslint-disable-line
    if (!autoCall) {
      return
    }
    if (autoCall) {
      if (!companyId) {
        ShowAlert('waring', 'Beneficiary not valid!!');
        return
      }
      if (companyId && companyId.length === 24) {
        try {

          let res = await qrCall(companyId ? companyId : "", coords?.latitude ? String(coords.latitude) : null, coords?.longitude ? String(coords.longitude) : null)
          if (res.data.message.includes('ticket already created ticketId')) {

            ShowAlert('warning', 'Ticket has already created!')
          } else {

            ShowAlert('success', 'Please wait, Our team will reach out to you soon!')
          }
          setButtonClicked(true);
          setAutoCall(false);
          // window.location.href = `${wpBaseUrl}/home/`; 
          // navigate('/')
           setTimeout(() => {
          window.location.href = `${wpBaseUrl}/home/`;
        }, 4000);
        }
        catch (error: any) {
          error.response?.data?.message ? ShowAlert('warning', error.response?.data?.message) :
            ShowAlert('warning', "Please try again later!")

          console.error();
        }
      }
      else if (companyId && companyId.length === 10) {
        try {
           const res = await raiseEmergencyWithCompanyIdAction(companyId, null, coords?.latitude ? String(coords.latitude) : null, coords?.longitude ? String(coords.longitude) : null) 
          if (res?.data?.statusCode === 202) {
            setButtonClicked(true);
            setAutoCall(false);
            ShowAlert('warning', res?.data?.message)
            // navigate('/')
            // window.location.href = `${wpBaseUrl}/home/`;
            setTimeout(() => {
              window.location.href = `${wpBaseUrl}/home/`;
            }, 10000);

            return
          }
          if (res.data.message.includes('ticket already created ticketId')) {
            ShowAlert('warning', 'Ticket has already created.')
          } else {

            ShowAlert('success', 'Please wait, Our team will reach out to you soon!')
          }
          setButtonClicked(true);
          setAutoCall(false);
          // navigate('/')
          // window.location.href = `${wpBaseUrl}/home/`;
           setTimeout(() => {
          window.location.href = `${wpBaseUrl}/home/`;
        }, 4000);
        } catch (error: any) {
          error.response?.data?.message ? ShowAlert('warning', error.response?.data?.message) :
            ShowAlert('warning', "Please try again later!")
          console.error();
          return;
        }
      } else {
        ShowAlert("warning", "Invalid BenId Or Invalid CompanyId");
      }

    }

  };

  const handleCall = async () => {
    if (!mobile) {
      return ShowAlert("warning", "Phone number is required");
    }

    if (mobile.length !== 10) {
      return ShowAlert(
        "warning",
        "Phone number should be exactly 10 digits"
      );
    }

    if (companyId && companyId.length === 24) {

      try {
        let res = await qrEmergencyWithMobile(companyId ? companyId : "", mobile, coords?.latitude ? String(coords.latitude) : null, coords?.longitude ? String(coords.longitude) : null)
        if (res.data.message.includes('ticket already created ticketId')) {
          ShowAlert('warning', 'Ticket has already created.')
        } else {

          ShowAlert('success', 'Please wait, Our team will reach out to you soon!')
        }
        setButtonClicked(true);
        setAutoCall(false);
        // window.location.href = `${wpBaseUrl}/home/`;
        // navigate('/')
        setTimeout(() => {
          window.location.href = `${wpBaseUrl}/home/`;
        }, 4000);
      } catch (error: any) {
        error.response?.data?.message ? ShowAlert('warning', error.response?.data?.message) :
          ShowAlert('warning', "Please try again later!")

        console.error();
        return;
      }
    }
    else if (companyId && companyId.length === 10) {
      try {
        const res = await raiseEmergencyWithCompanyIdAction(companyId, mobile, coords?.latitude ? String(coords.latitude) : null, coords?.longitude ? String(coords.longitude) : null)
         console.log(res,"response")
        if (res.data.message.includes('ticket already created ticketId')) {
          ShowAlert('warning', 'Ticket has already created.')
        } else {

          ShowAlert('success', 'Please wait, Our team will reach out to you soon!')
        }
        setButtonClicked(true);
        setAutoCall(false);
        // navigate('/')
        // window.location.href = `${wpBaseUrl}/home/`;
         setTimeout(() => {
          window.location.href = `${wpBaseUrl}/home/`;
        }, 4000);
      } catch (error: any) {
        error.response?.data?.message ? ShowAlert('warning', error.response?.data?.message) :
          ShowAlert('warning', "Please try again later!")
        console.error();
        return;
      }
    } else {
      // console.log('companyId:', companyId);
      ShowAlert("warning", "Invalid BenId Or Invalid CompanyId");
      // navigate('/');
    }
  };

  const findBenHasMappedId=async(dubId:string)=>{
    try {
      // console.log('dubId:', dubId)
      const res=await checkBenIdIsMapped(dubId.slice(4));
      if(res.data){
    // console.log('res.data:',     res.data);
    const benId = res.data.res.benId;
    const currentUrl = new URL(window.location.href);
    // console.log('dubId:', dubId);
    // console.log('currentUrl:', currentUrl);
    const newPathname = currentUrl.pathname.replace(dubId, benId);
    // console.log('newPathname:', newPathname);
    // Update the URL with the new pathname
    //  window.history.pushState({}, "", `${newPathname}${currentUrl.search}`);//this will add to history not render again 
    navigate(newPathname, { replace: true }); // this will render when u update and company id set to the benId
  }
      
    } catch (error:any) {
      // console.log('error:', error.response?.data?.statusCode === 404);
      if ( error.response?.data?.statusCode === 404) {
       
        // Redirect to mapping page only if not already handled
        sessionStorage.setItem("benMapping", JSON.stringify(dubId));
        setIsQrMapped(!isQrMapped);
        // setErrorHandled(true); // Mark the error as handled
       
      } else{
        ShowAlert(
          "warning",
          "Some Technical Issue in Mapping BenId Try Again Later"
        );
        setErrorHandled(true); // Mark the error as handled
    
        // return window.location.href = "/";
   
      };
         
    }
  };
  const handleRedirect = () => {
    // setIsModalOpen(false);
    errorHandled?window.location.href = `${wpBaseUrl}/home/`:  navigate("/ben-qr-map"); // Redirect to homepage
  };

  const handleCloseModal=()=>{
    setErrorHandled(false);
    setIsQrMapped(false);
  }

  useEffect(() => {

    if(companyId?.includes("dup") &&!errorHandled){
      // console.log(companyId);
      // const bulkQrId = companyId.slice(4)
      findBenHasMappedId(companyId);
    }
    else if (companyId && companyId.length === 24) {
      axios.get(`${baseUri}/beneficiary/api/v1/temp-ben/${companyId}`).then((res) => {
        if (res.data.activated === false) {
          sessionStorage.setItem('companyLogo', res.data.company.logo);
          return navigate(`/activateAccount/${companyId}`)
        }
      }).catch((err: any) => {
        console.log(err)
      })
    }else{
      return;
    }
    
    ///duplicate_id flow----------

  }, []) //  eslint-disable-line 

  return (
    <>
    {(errorHandled||isQrMapped)&&
     <Modal isOpen={true} onClose={handleCloseModal} closeOnOverlayClick={false} closeOnEsc={false}>
     <ModalOverlay />
     <ModalContent>
       <ModalHeader>Error</ModalHeader>
       <ModalBody>{errorHandled?"Some Technical Issue in Checking Qr Mapping":"The scanned QR is not mapped to the beneficiary. Click to map the QR"}</ModalBody>
       <ModalFooter>
         <Button colorScheme="blue" onClick={handleRedirect}>
         { errorHandled? "Try Again":"Map Qr"}
         </Button>
       </ModalFooter>
     </ModalContent>
   </Modal>
    }
      <div className={TriggerEmergencyStyle.main}>
        <Image
          width={"80"}
          paddingTop={"10px"}
          marginLeft={"10px"}
          src="/Images/logo.png"
        />
        <div className={TriggerEmergencyStyle.container}>
          <Heading marginBottom={"20px"}>
            {isSso ? "Stay calm! Help is on the way." : "Hello from Pococare Heartbeat Team,"}
          </Heading>
          {!isSso && (
            <Heading marginBottom={"20px"} as="h3" size="md">
              Thank you for scanning the QR code of a registered beneficiary to notify an emergency.
            </Heading>
          )}
          <Heading marginBottom={"20px"} as="h3" size="md" fontWeight={isSso ? "normal" : "bold"}>
            {isSso
              ? <>Enter your phone number below. A <strong>Pococare Heartbeat Angel</strong> will call you immediately to assist with instant remote doctor consultation and emergency ambulance dispatch.</>
              : "Please enter your 10 digit mobile number. Our agent will call you right away."}
          </Heading>
          <InputGroup>
            <InputLeftAddon children="+91" />
            <Input
              value={mobile}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/\D/g, "");
                const formattedValue = inputValue.slice(0, 10);
                setMobile(formattedValue)
              }}
              type="tel"
              placeholder={isSso ? "Enter 10-digit mobile number" : "Phone Number"}
            />
          </InputGroup>
          <Button
            isDisabled={buttonClicked ? true : false}
            colorScheme="green"
            onClick={handleCall}
            minWidth={"100%"}
            marginTop={"10px"}
          >
            {isSso ? "Call Me Immediately" : "Receive a call"}
          </Button>
          {((companyId) &&( companyId.length < 10||companyId.includes("dup"))) ? (
            ""
          ) : (
            <p
              style={{
                fontSize: "20px",
                fontWeight: isSso ? "normal" : "bold",
                marginTop: "20px",
              }}
            >
              {isSso ? "Waiting for your number to initiate the call (" : "We are waiting for you to enter call back phone number, in next "}
              <Timer type="call" handleCall={handleAutoCall} time={60} />
              {isSso ? "s)" : " seconds"}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default TriggerEmergency
